import React, { useEffect, useRef, useState } from "react";
import { BiChevronDown } from "react-icons/bi";
import { AiOutlineSearch } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useCurrent } from "../../hooks";
import useFetch from "../../hooks/useFetch";

const MwSelectorAccount = ({
  onChangeCallback,
  withLabel = false,
  invalid = false,
  initialValue = "",
  disabled = false,
  placeholder = "",
  classNamePrivate = "",
}) => {
  const [t] = useTranslation("global");
  const { currentLangId } = useCurrent();
  const [inputValue, setInputValue] = useState(initialValue);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const { data, loading } = useFetch(
    searchTerm.trim()
      ? `https://emdad.sellatechnology.com/acc/api/tree-account/search/${searchTerm}`
      : null
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAccountSelect = (account) => {
    const displayValue = `${account.account_no} / ${account.name_en} / ${account.name_ar}`;

    setInputValue(displayValue);
    setSearchTerm("");
    onChangeCallback(account);
    setOpen(false);
  };

  return (
    <div className={`relative mw-selector-container ${classNamePrivate}`} ref={dropdownRef}>
      {withLabel && (
        <label className="text-xs text-[#251658] font-[700]">
          {t("invoice.selectAccount")}
        </label>
      )}

      <div
        onClick={() => !disabled && setOpen((prev) => !prev)}
        className={`h-9 bg-white border-[#8D82B6] mt-0 w-full flex items-center text-sm justify-between rounded border ${
          invalid ? "border-red-400" : "border-[#8D82B6] border-opacity-55"
        } ${disabled ? "text-slate-200 cursor-not-allowed" : "text-slate-600 cursor-pointer"}`}
      >
        <input
          type="text"
          disabled={disabled}
          value={inputValue}
          className="text-start px-3 border-0 text-black w-full outline-none cursor-pointer"
          placeholder={placeholder}
          onChange={(e) => {
            setInputValue(e.target.value);
            setSearchTerm(e.target.value);
            setOpen(true);
          }}
        />
        <BiChevronDown size={20} className="border rounded m-2" />
      </div>

      {open && (
        <ul className="bg-white border-b-2 border-x-2 z-50 overflow-y-auto absolute w-full rounded-b-lg max-h-60">
          <div className="sticky top-0 p-3 bg-white">
            <div className="flex items-center px-2 bg-white rounded border border-gray-300">
              <AiOutlineSearch size={18} className="text-gray-700" />
              <input
                type="text"
                placeholder={placeholder || "Enter Account Name"}
                className="placeholder:text-gray-700 p-2 outline-none w-full text-sm bg-white text-black"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {loading && <div className="p-4 text-center text-[#261759]">Loading...</div>}
          {!loading && (!data?.data || data.data.length === 0) && (
            <div className="p-4 text-center text-[#261759]">Not Found</div>
          )}

          <div className="max-h-[300px] overflow-y-auto">
            {!loading &&
              data?.data?.map((account) => (
                <li
                  key={account.id}
                  onClick={() => handleAccountSelect(account)}
                  className="ps-5 py-2 border-b text-sm hover:bg-sky-200 hover:text-white cursor-pointer"
                >
                  <div className="flex justify-between">
                    <div>
                      <div className="text-black">
                        {currentLangId === "ar" ? account.name_ar : account.name_en}
                      </div>
                      <div className="text-xs text-slate-400">{account.account_no}</div>
                    </div>
                  </div>
                </li>
              ))}
          </div>
        </ul>
      )}
    </div>
  );
};

export default MwSelectorAccount;
